import { LoaderService } from './../../services/loader.service';
import { FloorPlan } from './../../model/floorplan.model';
import { MiddlewareService } from './../../services/middleware.service';
import { Observable, of } from 'rxjs';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as FloorPlanActions from '../actions/floorplan.actions';
import * as ImageActions from '../actions/image.actions';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class ImageEffects {
    
    constructor(
        private actions$: Actions,
        private loader: LoaderService,
        private service: MiddlewareService
    ) {}

    @Effect()
    getImage$: Observable<Action> = this.actions$.pipe(
        ofType(ImageActions.GET_IMAGE),
        map((action: ImageActions.GetImage) => action.payload),
        mergeMap((filename) => {
          return this.service.getPng(filename + '.png')
            .pipe(
              map((image: any) => {
                return new ImageActions.SetImage({filename: filename, image: image});
              }),
              catchError(() => {
                return of(undefined);
              })
            )
        })
    )

    @Effect()
    setImage$: Observable<Action> = this.actions$.pipe(
        ofType(ImageActions.SET_IMAGE),
        map((action: ImageActions.SetImage) => action.payload),
        mergeMap(res => {
          return this.service.getFloorPlan(res.filename).pipe(
            map((plan: FloorPlan) => {
              const testata = plan.testata[0] ? plan.testata[0] : plan.testata;
              testata.formato_foglio = testata['formato foglio'];
              testata.formato_immagine = testata['formato immagine'];
              testata.nome_file = testata['nome file'];
              plan.testata = testata;
              if (plan.poligono) {
                plan.poligono.forEach((val, idx) => {
                  val.id = 'polygon_' + idx;
                });
              }
              return new FloorPlanActions.SetFloorplan(plan);
            }),
            catchError(() => {
              return of(undefined);
            })
          )
        })
    )
}